export const initialise = () => {
    const page: HTMLBodyElement | null = document.querySelector('.page-job-results')
    if (!page) return;

    jobFiltersClickHandler(page);
    jobFiltersLocationClickHandler(page);
    moveKeyword(page);
}

const jobFiltersClickHandler = (page: HTMLBodyElement) => {
    const filters: NodeListOf<HTMLDivElement> = page.querySelectorAll('.optionfiltergroup')

    filters.forEach((filter: HTMLDivElement) => {
        moveClearButton(filter)
        const filterHeader = filter.querySelector<HTMLHeadingElement>('.option-type-header')
        if (!filterHeader) return

        const filterList = filter.querySelector<HTMLUListElement>('.option-display-list')
        if (!filterList) return

        filterList.setAttribute('aria-hidden', 'true')
        filterHeader.setAttribute('aria-expanded', 'false')

        filterHeader.addEventListener('click', function(event: Event) {
            const target: HTMLHeadingElement = event.target as HTMLHeadingElement
            const expanded = target.getAttribute('aria-expanded') === 'true'
            target.setAttribute('aria-expanded', String(!expanded))
            filterList.setAttribute('aria-hidden', String(!expanded))
            
            document.addEventListener('click', function clickAway(event: Event) {
                const target: HTMLElement = event.target as HTMLElement
                if (!filter.contains(target)) {
                    filter.classList.remove('category-opened')
                    filterHeader.setAttribute('aria-expanded', 'false')
                    filterList.setAttribute('aria-hidden', 'true')
                    document.removeEventListener('click', clickAway)
                }
            })

            document.addEventListener('keyup', function keyboardAway(event: KeyboardEvent) {
                if (event.key === 'Escape' || !filter.contains(document.activeElement)) {
                    filter.classList.remove('category-opened')
                    filterHeader.setAttribute('aria-expanded', 'false')
                    filterList.setAttribute('aria-hidden', 'true')
                    document.removeEventListener('keyup', keyboardAway)
                }
            })
            
            const openedFilters: NodeListOf<HTMLDivElement> = page.querySelectorAll('.category-opened')
            if (filter.classList.contains('category-opened')) {
                filterHeader.setAttribute('aria-expanded', 'false')
                filterList.setAttribute('aria-hidden', 'true')
                filter.classList.remove('category-opened')

            } else {
                openedFilters.forEach((filter: HTMLDivElement) => {
                    filter.querySelector('.option-type-header')?.setAttribute('aria-expanded', 'false')
                    filter.querySelector('.option-display-list')?.setAttribute('aria-hidden', 'true')
                    filter.classList.remove('category-opened')
                })
                filter.classList.toggle('category-opened')
                filterHeader.setAttribute('aria-expanded', 'true')
                filterList.setAttribute('aria-hidden', 'false')
            }
        })
    })
}


export const jobFiltersLocationClickHandler = (page: HTMLBodyElement) => {
    const filter = page.querySelector<HTMLDivElement>('.location-filter')
    if (!filter) return

    const filterHeader = filter.querySelector<HTMLHeadingElement>('.header')
    if (!filterHeader) return

    filterHeader.addEventListener('click', () => {
        filter.classList.toggle('category-opened')
    })
}

export const moveKeyword = (page: HTMLBodyElement) => {
    const keyword: HTMLElement | null = page.querySelector(
        "#keyword-option-wrapper"
    );

    if (!keyword) return;

    const container = document.querySelector(".summary-text-widget");
    container?.append(keyword);

    keyword.style.display = "flex";
};

const moveClearButton = (filter: HTMLDivElement) => {
    const clearBtn = filter.querySelector('.job-filter-clear-group-btn')
    const applyBtnContainer = filter.querySelector('.apply-filters-btn-container')
    if (!clearBtn || !applyBtnContainer) return

    applyBtnContainer.appendChild(clearBtn)
}